import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import SubscriptionCard from "./SubscriptionCard";
import SubscribeButton from "./SubscribeButton";


const OurFeaturedProductsMsite = () => {
  const [selectedTitle, setSelectedTitle] = useState("Expert Advice")

  const handleSelect = (title) => {
    setSelectedTitle(title);
  }

  return (
    <Container
      disableGutters
      sx={{
        bgcolor: "#160e2c",
        maxWidth: "480px !important",
        minHeight: 852,
        mx: "auto",
        overflow: "hidden",
      }}

    >
      <Box
        sx={{
          minHeight: 716,
          fontFamily: "Inter, -apple-system, Roboto, Helvetica, sans-serif",
          fontSize: 17,
        }}
        mt={7}
      >
        <Box sx={{ bgcolor: "#160b29", pb: 2, overflow: "hidden" }}>
          <Box sx={{ bgcolor: "#150b28", width: "100%" }}>
            <Typography
              sx={{
                color: "#fff",
                letterSpacing: "-0.24px",
                fontSize: 24,
                fontWeight: 600,
                fontFamily: "Inter600",
                lineHeight: 1.3,
                p: "24px 16px 4px",
              }}
            >
              Our Products
            </Typography>
          </Box>

          <Box sx={{ p: 2 }}>
            {[
              { title: "Expert Advice", price: "4,999", img: "https://cdn.builder.io/api/v1/image/assets/TEMP/1424884227894156d403096f5c13788bb321cf28?placeholderIfAbsent=true&apiKey=1da4f08a4e1148f8818ef8fb1ffd088b" },
              { title: "Wealth Vaults", price: "2,999", img: "https://cdn.builder.io/api/v1/image/assets/TEMP/c2a27468fe7729978ea11f65fd49991446cccda2?placeholderIfAbsent=true&apiKey=1da4f08a4e1148f8818ef8fb1ffd088b" },
              { title: "Demat Account", price: "399", img: "https://cdn.builder.io/api/v1/image/assets/TEMP/c2a27468fe7729978ea11f65fd49991446cccda2?placeholderIfAbsent=true&apiKey=1da4f08a4e1148f8818ef8fb1ffd088b" },
            ].map(({ title, price, img }) => (
              <SubscriptionCard
                key={title}
                image={img}
                title={title}
                price={price}
                isSelected={selectedTitle === title}
                onSelect={() => handleSelect(title)}
              />
            ))}
          </Box>

          <Box sx={{ p: 2 }}>

            <SubscribeButton />
          </Box>

        </Box>
      </Box>
    </Container>
  );
};

export default OurFeaturedProductsMsite;
